let disabled = false;

function disableTemporarily() {
  disabled = true;
  setTimeout(() => (disabled = false), 500);
}

export function init() {
  document.querySelectorAll(".js-nav-icon-content").forEach((element) => {
    element.addEventListener(
      "click",
      (event) => {
        if (!disabled) {
          disableTemporarily();
          // if the user clicked on the padding of the nav icon content element, and not on the icon,
          // forward the click to the icon.
          if (event.target.tagName !== "A" && event.target.tagName !== "IMG") {
            event.preventDefault();
            event.stopPropagation();
            const targets = element.querySelectorAll("a, img");
            const target = targets[targets.length - 1];
            target.click();
          }
        }
      },
      true
    );
  });
}

if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}
